import http, { expandURI } from '@/utils/ajax'
import { PAYMENT_INIT_LOADING, PAYMENT_INIT_SUCCESS, PAYMENT_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async paymentInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.payment
    const expand = {}
    if (apiUrl) {
      commit(PAYMENT_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(PAYMENT_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(PAYMENT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PAYMENT_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
